export const cititesColums = [
  {
    name: "Nombre",
    selector: (row) => row["name"],
    sortable: true,
    center: false,
  },
  {
    name: "Uid",
    selector: (row) => row["uuid"],
    sortable: true,
    center: false,
  },
  {
    name: "Provincia",
    selector: (row) => row?.province?.name,
    sortable: true,
    center: false,
  },
];
